<template>
  <div class="md-layout md-alignment-center-center flex-1">
    <div
      class="md-layout-item md-small-size-100 md-large-size-50 md-xlarge-size-33"
    >
      <md-card>
        <md-card-header data-background-color="secondary">
          <h4 class="title">403: Forbidden</h4>
        </md-card-header>
        <md-card-content>
          <p class="category">
            You do not have permission to view this page.<br /><br />
            If you believe this shouldn't have happened, please contact support.
          </p>
          <md-button to="dashboard" class="md-raised md-success my-4 float-end"
            >Back to Dashboard</md-button
          >
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "Forbidden"
};
</script>

<style scoped></style>
